import React, { useEffect, useState } from "react"
import { DeleteTagResponse, TagList } from "../types"
import { FetchFromBackoffice, PostBackoffice } from "../../../utils/request";
import { CreateTag } from "./createTag";
import { TagsList } from "./tagsList";
import { SubpageTitle } from "../../../components/atoms/text/titles";
import { TextField, Typography } from "@mui/material";

import { AddModal } from "../../../components/molecules/AddModal";

export const TagsPage = () => {

  const [tags, setTags] = useState<TagList[]>([])
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [editTagName, setEditTagName] = useState({ id: '', text: '' });
  const [savingState, setSavingState] = useState<"idle" | "saving" | "failed">("idle");


  const fetchTagsList = async () => {
    try {
      const tags = await FetchFromBackoffice<TagList[]>('dashboard/tags')
      setTags(tags)
    } catch (error) {
      console.error('Failed to fetch tags:', error)
    }
  }

  const deleteTag = async (tagId: string) => {
    try {
      await PostBackoffice<DeleteTagResponse>('cmd/tags/delete', { id: tagId });
      setTags(prev => {
        const filtered = prev.filter(tag => tag.tagId !== tagId);
        return filtered;
      });
    } catch (error) {
      console.error('Could not delete tag:', error);
    }
  };


  const editTag = async (tagId: string, newText: string) => {
    setSavingState("saving");
    try {
      await PostBackoffice('cmd/tags/change/text', { id: tagId, text: newText });
      setTags(prev => prev.map(tag => tag.tagId === tagId ? { ...tag, text: newText } : tag))
      setModalOpen(false)
    } catch (error) {
      console.error('Could not edit tag:', error);
      setSavingState("failed");
    } finally {
      setSavingState("idle")
    }
  };


  useEffect(() => {
    fetchTagsList()
  }, [])

  const openEditModal = (id: string, text: string) => {
    setEditTagName({ id, text });
    setModalOpen(true);
  };

  return (
    <>
      <div>
        <SubpageTitle title={'Tags'} />
        <CreateTag
          existingTags={tags.map(({ tagId, text, colorCode }) => ({
            id: tagId,
            text,
            colorCode
          }))}

          onTagSaved={(tag) =>
            setTags(c =>
              [...c, {
                tagId: tag.id,
                text: tag.text,
                colorCode: tag.colorCode
              }].sort((a, b) => a.text.localeCompare(b.text))
            )
          }
        />
      </div>
      {tags.length === 0 && (
        <Typography>No tags created yet.</Typography>
      )}

      <div style={{ margin: "20px 0px" }}>
        {tags.map((tag) => (
          <span key={tag.tagId}>
            <TagsList
              id={tag.tagId}
              text={tag.text}
              colorCode={tag.colorCode ?? ""}
              onDelete={deleteTag}
              onEditTag={() => openEditModal(tag.tagId, tag.text)} />
          </span>
        ))}
      </div>
      <AddModal
        title="Edit Tag Name"
        savingFailedMessage="Failed to save tag name. Try again."
        open={modalOpen}
        savingDisabled={!editTagName.text}
        saving={savingState}
        onSave={() => editTag(editTagName.id, editTagName.text)}
        closeModal={() => {
          setModalOpen(false);
        }}
      >
        <TextField
          type="text"
          fullWidth
          placeholder="ID"
          value={editTagName.text}
          onChange={(e) => {
            setEditTagName({ ...editTagName, text: e.target.value })
          }}
        />
      </AddModal>


    </>
  )
}